<div class="row">
  <div class="col text-right">
    <button class="btn btn-primary" (click)="openCreateModal()" translate>CREATE_NEW</button>
  </div>
</div>

<div class="row" *ngIf="assortments.length == 0">
  <div class="col">
    <span class="no-assortments-found" translate>NO_ASSORTMENTS_FOUND</span>
  </div>
</div>

<div class="row">
  <div class="col">
    <div class="d-flex flex-row justify-content-between mb-3 assortment-entry" *ngFor="let assortment of assortments">
      <div class="d-flex flex-row align-items-center">
        <div class="d-flex flex-column">
          <span class="id">{{ assortment.id }}</span>
          <span class="name">{{ assortment.name }}</span>
        </div>
      </div>
      <div class="d-flex flex-row align-items-center">
        <lib-action-btn [item]="assortment" [config]="actionButtonConfig"></lib-action-btn>
      </div>
    </div>
  </div>
</div>
